import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import AudienceVideoPlayer from './audiences/AudienceVideoPlayer';
import MainContent from './layout/MainContent';
//Redux
import { getAudiencesAction } from '../actions/audiencesActions';
//Función principal
const VideoPlayer = () => {
    //Tomo los parametros
    const { id } = useParams();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    const authUser = useSelector(state => state.auth.user);
    //Tomo los datos al inicio
    useEffect(() => {
        //Tienen q haber datos de usuario
        if(authUser){
            //Busco datos de audiencia
            dispatch( getAudiencesAction(id, authUser) );
        }
    }, [id, authUser])
    //Nodos
    const nodes = [];
    //Acciones
    const actions = [];
    //Renderizo
    return (
        <MainContent 
            title={`Audiencia #${id}`}
            subtitle={`Videos`}
            nodes={nodes}
            actions={actions}
            component={AudienceVideoPlayer} />
    );
};

export default VideoPlayer;